export enum ENVIRONMENTS {
  STAGING = "staging",
  PRODUCTION = "production",
  LOCAL_SHEHAN = "local_shehan",
  LOCAL_ALI = "local_ali",
  LOCAL_SHAYAN = "local_shayan",
}
export const ENVIRONMENT_MODE: string = ENVIRONMENTS.PRODUCTION;

export const BASE_URLS: {
  [key: string]: {
    REACT_APP_API_BASE_URL: string;
  };
} = {
  production: {
    REACT_APP_API_BASE_URL: "https://backend.landscaling.com/",
  },
  staging: {
    REACT_APP_API_BASE_URL: "https://www.landscalingapi.darkhorsesolutions.co/",
  },
  local_shehan: {
    REACT_APP_API_BASE_URL: "http://192.168.100.215:3002/",
  },
  local_shayan: {
    REACT_APP_API_BASE_URL: "http://192.168.100.59:3000/",
  },
  local_ali: {
    REACT_APP_API_BASE_URL: "http://192.168.100.7:3000/",
  },
};
